import { DatePipe } from '@angular/common';
import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { EventoNotaFiscal } from 'src/app/models/fat/nota-fiscal/evento-nota-fiscal';
import { NotaFiscal } from 'src/app/models/fat/nota-fiscal/nota-fiscal';
import { AuthService } from 'src/app/services/auth/auth.service';
import { NotaFiscalService } from 'src/app/services/fat/nota-fiscal.service';
import { CustomSnackBarService } from 'src/app/shared/components/custom-snack-bar/custom-snack-bar.service';
import { TrataExcessao } from 'src/app/shared/utils/trata-excessao';

@Component({
  selector: 'app-evento-list-modal',
  templateUrl: './evento-list-modal.component.html',
  styleUrls: ['./evento-list-modal.component.scss']
})
export class EventoListModalComponent implements OnInit {
  isLoading = false;
  countLoading = 0;

  displayedColumns: string[] = 
  [
    "dataHoraEvento",
    "descTipoEvento",
    "infoEvento"
  ];

  dialogRef: MatDialogRef<EventoListModalComponent>;

  private dialogData:NotaFiscal;

  dataSource = new MatTableDataSource<EventoNotaFiscal>();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  constructor(
    private service: NotaFiscalService,
    private injector: Injector,
    private datePipe: DatePipe,
    private snackBar: CustomSnackBarService,
    private authService: AuthService,
    
  ) {
    
    this.dialogRef = this.injector.get(MatDialogRef);
    this.dialogData = this.injector.get(MAT_DIALOG_DATA, null);
  }

  closeModal() {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.pesquisar();
  }

  pesquisar() {

    this.exibirCarregando();
    this.service.pesquisaEventosNotaFiscal(this.dialogData.codigoDocumento).subscribe(
      (response) => {
        this.escondeCarregando();
        this.dataSource = new MatTableDataSource<EventoNotaFiscal>(response.body.retorno.registro);
        
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
      (err) => {
        this.escondeCarregando();
        TrataExcessao.TrataExcessao(err, this.authService, this.snackBar);
      }
    );
 }

  private exibirCarregando() {
    this.countLoading++;
    this.isLoading = true;
  }

  private escondeCarregando() {
    this.countLoading--;
    if (this.countLoading <= 0) {
      this.isLoading = false;
    }
  }

}
